import chartTitles from "./chartTitles.json";
import curveTerms from "./curveTerms.json";
import unitDictionary from "./unitDictionary.json";
import fluidTypes from "./fluidTypes.json";

// Словари загружаются из JSON: chartTitles — названия графиков (целых панелей),
// curveTerms — названия кривых/мнемоник, unitDictionary — единицы измерения.
const UNIT_DICTIONARY = unitDictionary as Record<string, string>;

// Названия графиков и кривых сопоставляются без учёта регистра.
const normalize = (dict: Record<string, string>) =>
  Object.entries(dict).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key.toLowerCase()]: value,
    }),
    {} as Record<string, string>
  );

const normalizedChartTitles = normalize(chartTitles);
const normalizedCurveTerms = normalize(curveTerms);
const normalizedFluidTypes = normalize(fluidTypes);

/** Перевод названия графика (целой панели). Если перевода нет — исходное значение. */
export const getChartTitleTranslation = (value: string) =>
  normalizedChartTitles[value.toLowerCase()] || value;

/** Перевод названия кривой/мнемоники. Если перевода нет — исходное значение. */
export const getCurveTermTranslation = (value: string) =>
  normalizedCurveTerms[value.toLowerCase()] || value;

/** Перевод типа жидкости (typeFluid). Если перевода нет — исходное значение. */
export const getFluidTypeTranslation = (value: string) =>
  normalizedFluidTypes[value.toLowerCase()] || value;

/** Перевод единицы измерения. Если перевода нет — исходное значение. */
export const getUnitTranslation = (value: string) => {
  const trimmed = value.trim();
  const exact = UNIT_DICTIONARY[trimmed];
  if (exact !== undefined) return exact;

  // Перевод не найден — показываем оригинал.
  return value;
};

export const isDateTimeMnemonic = (value: string) =>
  ["datetime", "time"].includes(value.toLowerCase());
